import React, { useState, useEffect } from "react";
import ArrearsSenventhForm1 from "./arrearsSenventhForm1";
import ArrearsSenventhForm2 from "./arrearsSenventhForm2";
import ArrearsSenventhForm3 from "./arrearsSenventhForm3";
import ArrearsSenventhForm4 from "./arrearsSenventhForm4";
import ArrearsSenventhForm5 from "./arrearsSenventhForm5";
import { useFormSubmission } from "../../pages/payment/customPayment";
import {
  handleFormDataChange,
  handleNextStep,
  handlePreviousStep,  
} from "../../components/formHandlers";
import "../../../style/google_forms.css";

const ArrearSeventh = () => {
  const initialFormState = {
    officeName: '',
    employeeName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    designation: '',
    accountNumber: 0,
    accountType: 'GPF',
    handicapped: false,
    professionalTax: false,
    CLA: false,
    CLADetails: [],

    arrearsStartDate: '',
    arrearsEndDate: '',
    specialAllowanceDue: [],
    specialAllowanceDrawn: [],

    firstIncrement: '',
    dueSalaryDetails: [],
    drawnSalaryDetails: [],
    hraDetails: [],

    isHoliday: false,
    holidays: [],

    isArrearsBeforeDate: false,
    newAppointment: '',
    duePaybandSixthPay: '',
    dueSalaryDetailsSixthPay: [],
    drawnSalaryDetailsSixthPay: [],

    specialNote: '',
  };

  const [formData, setFormData] = useState(initialFormState);
  const { handleFormSubmission, isSubmitting, PaymentWindowComponent } = useFormSubmission();
  const [step, setStep] = useState(1);

  // Safely update date in array
  const updateDateInArray = (arr, date) => {
    if (!Array.isArray(arr)) return [];
    if (arr.length === 0) return arr;
    
    return arr.map((item, index) => 
      index === 0 ? { ...item, date } : item
    );
  };

  // Update all arrays when start date changes
  const updateStartDateForArrays = (data) => {
    if (!data.arrearsStartDate) return data;
    
    return {
      ...data,
      CLADetails: updateDateInArray(data.CLADetails, data.arrearsStartDate),
      specialAllowanceDue: updateDateInArray(data.specialAllowanceDue, data.arrearsStartDate),
      specialAllowanceDrawn: updateDateInArray(data.specialAllowanceDrawn, data.arrearsStartDate),
      dueSalaryDetails: updateDateInArray(data.dueSalaryDetails, data.arrearsStartDate),
      drawnSalaryDetails: updateDateInArray(data.drawnSalaryDetails, data.arrearsStartDate),
      hraDetails: updateDateInArray(data.hraDetails, data.arrearsStartDate),
      dueSalaryDetailsSixthPay: updateDateInArray(data.dueSalaryDetailsSixthPay, data.arrearsStartDate),
      drawnSalaryDetailsSixthPay: updateDateInArray(data.drawnSalaryDetailsSixthPay, data.arrearsStartDate)
    };
  };

  // Update form data when start date changes
  useEffect(() => {
    if (formData.arrearsStartDate) {
      setFormData(prev => updateStartDateForArrays(prev));
    }
  }, [formData.arrearsStartDate]);

  const handleNext = () => handleNextStep(setStep);
  const handleBack = () => handlePreviousStep(setStep);

  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/arrearesSeventh/submit`,
    paymentDescription: "Payment for Seventh Pay Arrears Form",
    successRoute: "/arrearesSeventh/arrears_seventh_result",
    name: formData.employeeName,
    formType: "Arrears_Seventh",
    email: formData.email,
    contact: formData.phoneNumber,
    onSuccessCallback: () => localStorage.clear()
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.employeeName || !formData.email || !formData.phoneNumber) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Required Fields',
        text: 'Please fill all required fields before submitting.'
      });
      return;
    }    
    // Ensure all arrays are properly initialized before submission
    const submissionData = updateStartDateForArrays({
      ...formData,
      CLADetails: formData.CLADetails || [],
      specialAllowanceDue: formData.specialAllowanceDue || [],
      specialAllowanceDrawn: formData.specialAllowanceDrawn || [],
      dueSalaryDetails: formData.dueSalaryDetails || [],
      drawnSalaryDetails: formData.drawnSalaryDetails || [],
      hraDetails: formData.hraDetails || [],
      dueSalaryDetailsSixthPay: formData.dueSalaryDetailsSixthPay || [],
      drawnSalaryDetailsSixthPay: formData.drawnSalaryDetailsSixthPay || []
    });

    handleFormSubmission(submissionData, formConfig);
  };

  // Load saved form data
  useEffect(() => {
    const savedFormData = JSON.parse(localStorage.getItem("formData"));
    if (savedFormData) {
      setFormData(updateStartDateForArrays({
        ...initialFormState,
        ...savedFormData,
        // Ensure all arrays exist
        CLADetails: savedFormData.CLADetails || [],
        specialAllowanceDue: savedFormData.specialAllowanceDue || [],
        specialAllowanceDrawn: savedFormData.specialAllowanceDrawn || [],
        dueSalaryDetails: savedFormData.dueSalaryDetails || [],
        drawnSalaryDetails: savedFormData.drawnSalaryDetails || [],
        hraDetails: savedFormData.hraDetails || [],
        dueSalaryDetailsSixthPay: savedFormData.dueSalaryDetailsSixthPay || [],
        drawnSalaryDetailsSixthPay: savedFormData.drawnSalaryDetailsSixthPay || []
      }));
    }
  }, []);

  return (
    <div>
      {step === 1 && (
        <ArrearsSenventhForm1
          formData={formData}
          setFormData={setFormData}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}
      {step === 2 && (
        <ArrearsSenventhForm2
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onNext={handleNext}
        />
      )}
      {step === 3 && (
        <ArrearsSenventhForm3
          formData={formData}
          setFormData={setFormData}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onBack={handleBack}
          onNext={handleNext}
        />
      )}
      {step === 4 && (
        <ArrearsSenventhForm4
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onNext={handleNext}
        />
      )}
      {step === 5 && (
        <ArrearsSenventhForm5
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onSubmit={handleSubmit}
        />
      )}
      {PaymentWindowComponent}
    </div>
  );
};

export default ArrearSeventh;